import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "info-dashboard-container" }
const _hoisted_2 = { id: "info-dashboard-subheader" }
const _hoisted_3 = {
  key: 0,
  class: "subheader-item"
}
const _hoisted_4 = { id: "info-dashboard-content" }
const _hoisted_5 = { id: "info-dashboard-footer" }

import FeatureChildren from '@/components/FeatureChildren.vue'
import useReportPoi from '@/hooks/reports/useReportPoi'
import { storeToRefs } from 'pinia'
import { useSelectionStore } from '@/pinia/selection'
import { useI18n } from 'vue-i18n'
import { Feature } from '@/pinia/feature'
import { computed } from 'vue'
import {
  generateEntityInformation,
  generateLineInformation,
  generatePoiInformation,
  generateZoneInformation,
  InfoData
} from '@/utils/entityInformation'
import BadgeSquare from '@/design-system/atoms/BadgeSquare.vue'
import IconInfoCircle from '@/design-system/assets/icons/IconInfoCircle.vue'
import { subHeaderItem, useEntitySubHeaders } from '@/utils/entitySubHeaders'
import useReportRoom from '@/hooks/reports/useReportRoom'
import { useReport } from '@/hooks/reports/useReport'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoDisplayDashboard',
  props: {
    children: {},
    title: {}
  },
  setup(__props: any) {



const { t } = useI18n()
const entityHeaders = useEntitySubHeaders()
const selectionStore = useSelectionStore()
const { clickedEntityType, currentEntity, currentLoading } = storeToRefs(selectionStore)
const poiReport = useReportPoi()
const roomReport = useReportRoom()
const { report, isLoading } = storeToRefs(useReport())

const lineSummaryData = computed(() => {
  return report.value?.lineSummaryData ?? []
})
const poiSummaryData = computed(() => {
  return report.value?.poiSummaryData ?? []
})
const subHeaderItems = computed<subHeaderItem[]>(() => {
  if (clickedEntityType.value === 'CONSTRUCTION')
    return entityHeaders.generateConstructionSubHeaders(currentEntity.value)
  if (clickedEntityType.value === 'LEVEL')
    return entityHeaders.generateLevelSubHeaders(currentEntity.value)
  if (clickedEntityType.value === 'SPACE')
    return entityHeaders.generateSpaceSubHeaders(currentEntity.value)
  if (clickedEntityType.value === 'POI') return entityHeaders.generatePoiSubHeaders()
  if (clickedEntityType.value === 'LINE') return entityHeaders.generateLineSubHeaders()
  if (clickedEntityType.value === 'ZONE') return entityHeaders.generateZoneSubHeaders()
  return []
})
const zoneSummaryData = computed(() => {
  return report.value?.zoneSummaryData ?? []
})

const infoData = computed<InfoData[]>(() => {
  let data: InfoData[] = []
  if (
    clickedEntityType.value !== 'POI' &&
    clickedEntityType.value !== 'LINE' &&
    clickedEntityType.value !== 'ZONE' &&
    clickedEntityType.value !== 'REGION' &&
    currentEntity.value
  ) {
    data = generateEntityInformation(currentEntity.value)
    return data
  } else if (clickedEntityType.value === 'POI') {
    data = generatePoiInformation(poiReport)
    return data
  } else if (clickedEntityType.value === 'LINE') {
    data = generateLineInformation()
    return data
  } else if (clickedEntityType.value === 'ZONE') {
    data = generateZoneInformation()
    return data
  }

  return []
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subHeaderItems.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (!item.isBadge)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(item.text), 1))
            : (_openBlock(), _createBlock(BadgeSquare, {
                key: 1,
                badgeText: item.text,
                class: "subheader-item",
                size: "small"
              }, null, 8, ["badgeText"]))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(FeatureChildren, {
        feature: "home/info/info/general",
        contentData: _unref(report)?.groupData,
        contentTitles: _unref(report)?.groupTitles,
        measurements: _unref(report)?.measurements,
        currentEntity: _unref(currentEntity),
        isLoading: (_unref(currentLoading) || _unref(isLoading)) ?? false,
        lineSummaryData: lineSummaryData.value,
        indoorData: _unref(roomReport)?.measurements.value ?? [],
        infoData: infoData.value,
        poiSummaryData: poiSummaryData.value,
        zoneSummaryData: zoneSummaryData.value,
        overviewData: _unref(report)?.summaryReport,
        poiMetaInfo: _unref(poiReport)?.metaInfo.value ?? []
      }, null, 8, ["contentData", "contentTitles", "measurements", "currentEntity", "isLoading", "lineSummaryData", "indoorData", "infoData", "poiSummaryData", "zoneSummaryData", "overviewData", "poiMetaInfo"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(IconInfoCircle, { class: "info" }),
        _createElementVNode("p", null, _toDisplayString(_unref(t)('info__data-displayed')), 1)
      ])
    ])
  ]))
}
}

})